import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import { selectCompanyRegistration } from "../../../redux/preferences/selectors";
import { connect } from "react-redux";
import { history } from "../../../redux/store";
import CompanySubContactorForm from "./CompanySubContactorForm";
import {
  createSubContractor,
  getSubContractor,
  updateSubContractor
} from "../../../services/api/subcontractors";
import { ajaxErrorHandler, defaultSuccess } from "../../../libs/utils";
import { USER_ACTIONS } from "../../../redux/auth/actions";

const CompanySubContractors = ({ registration, match, refreshUserData }) => {
  const id = match.params.id;
  const [subContractor, setSubcontractor] = useState();

  const _submitHandler = values => {
    return new Promise((resolve, reject) => {
      if (subContractor) {
        updateSubContractor(registration.id, subContractor.id, values)
          .then(response => {
            defaultSuccess("Subcontractor updated");
            refreshUserData();
            history.push("/company");
          })
          .catch(e => {
            ajaxErrorHandler(e);
            reject();
          });
      } else {
        createSubContractor(registration.id, values)
          .then(response => {
            console.log(response);
            defaultSuccess("Subcontractor added");
            refreshUserData();
            history.push("/company");
          })
          .catch(e => {
            ajaxErrorHandler(e);
            reject();
          });
      }
    });
  };

  useEffect(() => {
    if (id) {
      getSubContractor(registration.id, id).then(response => {
        console.log(response);
        setSubcontractor(response);
      });
    }
  }, [id]);

  console.log(subContractor);

  return (
    <>
      <AdminSubHeader
        title="Create Subcontractor"
        key="subheader"
        breadcrumbs={[]}
      />
      <div className="m-content" key="content">
        <div className="row">
          <div className="col-xl-12">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-information" />
                    </span>
                    <h3 className="m-portlet__head-text">Subcontractor Info</h3>
                  </div>
                </div>
              </div>
              {id && !subContractor ? (
                <div className="m-portlet__body">
                  <div style={{ padding: "2.2rem" }}>
                    <div className="m-loader m-loader--accent m-loader--lg mt-2"></div>
                  </div>
                </div>
              ) : (
                <CompanySubContactorForm
                  onSubmit={_submitHandler}
                  subContractor={subContractor}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

CompanySubContractors.propTypes = {
  registration: PropTypes.object.isRequired
};

const mapStateToProps = function(state) {
  return {
    registration: selectCompanyRegistration(state)
  };
};

const mapDispatchToProps = dispatch => ({
  refreshUserData: () => dispatch(USER_ACTIONS.getDataRequest())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanySubContractors);
